import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=2fdfd107&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdfd107')) {
      api.createRecord('2fdfd107', component.options)
    } else {
      api.reload('2fdfd107', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=2fdfd107&", function () {
      api.rerender('2fdfd107', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/components/Button.vue"
export default component.exports